import { render, staticRenderFns } from "./WaterDetails.vue?vue&type=template&id=055275ea&scoped=true&"
import script from "./WaterDetails.vue?vue&type=script&lang=js&"
export * from "./WaterDetails.vue?vue&type=script&lang=js&"
import style0 from "./WaterDetails.vue?vue&type=style&index=0&id=055275ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055275ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBreadcrumbs,VBtn,VContainer,VIcon,VSimpleTable,VToolbarTitle})
